import { render } from "./PublishedBooks.vue?vue&type=template&id=39e5e566"
import script from "./PublishedBooks.vue?vue&type=script&lang=js"
export * from "./PublishedBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__